import { call, put, takeLatest } from "redux-saga/effects";
import { cameraEntryActionTypes as types } from "./cameraEntryTypes";
import {
  cameraApiResponseSuccess,
  cameraApiResponseError,
} from "./cameraEntryActions";

import {
  showErrorNotification,
  showSuccessNotification,
} from "../../helpers/NotificationContext";
import { submitImageEntryApi } from "../../api/cameraEntry"; // ← implement API wrapper

/* worker */
function* submitImageEntrySaga(action: any): any {
  try {
    const { file, fileType } = action.payload;
    console.log("submitImageEntrySaga → uploading", file, fileType);

    const response = yield call(submitImageEntryApi, { file, fileType });
    console.log("submitImageEntrySaga → response", response);

    yield put(cameraApiResponseSuccess(types.SUBMIT_IMAGE_ENTRY, response));
    showSuccessNotification("📸 Image entry submitted!");

  } catch (err: any) {
    console.error("submitImageEntrySaga error:", err.message);
    yield put(cameraApiResponseError(types.SUBMIT_IMAGE_ENTRY, err.message));
    showErrorNotification("Upload failed: " + err.message);
  }
}

/* root */
export default function* cameraEntrySaga() {
  yield takeLatest(types.SUBMIT_IMAGE_ENTRY, submitImageEntrySaga);
}
